import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Primary WhatsApp = Vile Parle centre by default for the main CTA band.
const WHATSAPP_URL = "https://wa.me/918779853459";

export default function CTABand() {
  return (
    <section className="relative py-24 lg:py-40 bg-[#1E1E1E] text-[#F5F4EF] overflow-hidden noise" data-testid="cta-band">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="max-w-4xl"
        >
          <div className="text-xs uppercase tracking-[0.28em] text-[#A67C00]">
            <span className="w-8 h-px bg-[#A67C00] inline-block align-middle mr-3" />
            Ready when you are
          </div>
          <h2 className="mt-8 font-display text-5xl md:text-7xl lg:text-8xl tracking-[-0.03em] leading-[0.9]">
            Let's start with a <br />
            <span className="italic font-medium text-[#A67C00]">conversation.</span>
          </h2>
          <p className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed">
            Tell us where you are, what you want to do, and what's getting in the way. We'll help you figure out the right place to start.
          </p>
          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank" rel="noopener noreferrer"
              data-testid="cta-whatsapp"
              className="group inline-flex items-center gap-3 bg-[#A67C00] text-[#1E1E1E] px-8 py-5 text-sm font-semibold hover:bg-[#F5F4EF] transition-colors duration-500"
            >
              Talk to us
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </a>
            <Link
              to="/book"
              data-testid="cta-book"
              className="group inline-flex items-center gap-3 border border-white/40 text-[#F5F4EF] px-8 py-5 text-sm font-medium hover:border-[#A67C00] hover:text-[#A67C00] transition-colors duration-500"
            >
              Book an Assessment
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
